export const accessConstante = Object.freeze({
  //levels
  ALL: 4,
  DELETE: 3,
  EDIT: 2,
  VIEW: 1,
  NONE: 0,

  //code
  STUDEA_MANAGER_REGISTRATION_ALERT_EDIT: "STUDEA_MANAGER_REGISTRATION_ALERT_EDIT",
  STUDEA_MANAGER_REGISTRATION_DASHBOARD: "STUDEA_MANAGER_REGISTRATION_DASHBOARD",
  STUDEA_MANAGER_REGISTRATION_ESTIMATE_PRICE: "STUDEA_MANAGER_REGISTRATION_ESTIMATE_PRICE",
  STUDEA_MANAGER_REGISTRATION: "STUDEA_MANAGER_REGISTRATION",
  STUDEA_MANAGER_REGISTRATION_VALIDATION: "STUDEA_MANAGER_REGISTRATION_VALIDATION",
  STUDEA_MANAGER_TRIAD: "STUDEA_MANAGER_TRIAD",
  STUDEA_MANAGER_TRAINING_GROUP_DELETE: "STUDEA_MANAGER_TRAINING_GROUP_DELETE",
  STUDEA_MANAGER_TRAINING_CONTACT: "STUDEA_MANAGER_TRAINING_CONTACT",
  STUDEA_MANAGER_VALIDATE_GROUP: "STUDEA_MANAGER_VALIDATE_GROUP",
  STUDEA_MANAGER_REGISTRATION_CONTACT_EDIT: "STUDEA_MANAGER_REGISTRATION_CONTACT_EDIT",
  STUDEA_MANAGER_PLACEMENT_CATALOGUE_EDIT: "STUDEA_MANAGER_PLACEMENT_CATALOGUE_EDIT",
  STUDEA_MANAGER_PLACEMENT_GROUPS_EDIT: "STUDEA_MANAGER_PLACEMENT_GROUPS_EDIT",
});
